// extracted by mini-css-extract-plugin
export default {"clipDownload":"VlZA_","clipDownloadInfo":"swwwH"};